"use client";

import { c as _c } from "react/compiler-runtime";
import { VercelToolbar } from "@vercel/toolbar/next";
import { FlagValues } from "flags/react";
import { ClearCacheButton } from "./clear-cache-button";
export function StaffToolbar(t0) {
  const $ = _c(6);
  const {
    encryptedFlagValues
  } = t0;
  let t1;
  if ($[0] !== encryptedFlagValues) {
    t1 = <FlagValues values={encryptedFlagValues} />;
    $[0] = encryptedFlagValues;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <VercelToolbar />;
    t3 = <ClearCacheButton />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <>{t1}{t2}{t3}</>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}